import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["slide", "dot", "accordionContent"]

  initialize() {
    this.currentSlideIndex = 0
    this.itemsPerPage = 3
    this.totalSlides = this.slideTargets.length
    this.updateSliderPosition()
  }

  nextSlide() {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % (this.totalSlides - this.itemsPerPage)
    this.updateSliderPosition()
  }

  prevSlide() {
    this.currentSlideIndex = (this.currentSlideIndex - 1 + this.totalSlides) % this.totalSlides
    this.updateSliderPosition()
  }

  goToSlide(event) {
    this.currentSlideIndex = parseInt(event.currentTarget.dataset.slideIndex, 10)
    this.updateSliderPosition()
  }

  updateSliderPosition() {
    const offset = -this.currentSlideIndex * (100 / this.itemsPerPage)
    this.slideTargets.forEach(slide => {
      slide.style.transform = `translateX(${offset}%)`
    })
    this.updateDots()
  }

  updateDots() {
    this.dotTargets.forEach((dot, index) => {
      dot.classList.toggle("w-active", index === this.currentSlideIndex)
    })
  }

  toggleAccordion(event) {
    const target = event.currentTarget
    const content = target.nextElementSibling
    const faqIcon = target.querySelector(".faq-icon")

    if (content.style.display === "block") {
      this.closeAccordion(target, content, faqIcon)
    } else {
      this.closeAll(target)
      this.openAccordion(target, content, faqIcon)
    }
  }

  closeAccordion(target, content, faqIcon) {
    content.style.display = "none"
    content.classList.remove("w--open")
    target.classList.remove("w--open")
    faqIcon.classList.remove("rotate")
  }

  openAccordion(target, content, faqIcon) {
    content.style.display = "block"
    content.classList.add("w--open")
    target.classList.add("w--open")
    faqIcon.classList.add("rotate")
    this.adjustOpacity(target.id)
  }

  closeAll(excludeTarget) {
    this.accordionContentTargets.forEach(content => {
      if (content.previousElementSibling !== excludeTarget) {
        this.closeAccordion(content.previousElementSibling, content, content.previousElementSibling.querySelector(".faq-icon"))
      }
    })
  }

  adjustOpacity(id) {
    const idsWithOpacity = ["nature", "playful", "childled", "wisdom"]
    const leftContentChildren = document.querySelectorAll(".left-content > div")

    leftContentChildren.forEach(child => {
      child.style.opacity = idsWithOpacity.includes(id) && child.classList.contains(id) ? "1" : "0"
    })
  }
}


// WEBPACK FOOTER //
// ./app/javascript/controllers/home_controller.js